import { motion } from 'framer-motion';

export default function MemeSubmitBanner() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="bg-gradient-to-r from-teal-500 to-teal-600 rounded-2xl p-8 text-white text-center my-10 relative overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-10 -left-10 w-40 h-40 bg-white/10 rounded-full blur-2xl" />
        <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-2xl" />
      </div>
      <div className="relative">
        <div className="text-4xl mb-3">😹</div>
        <h3 className="text-2xl font-black mb-2">Got a Hilarious Cat Meme?</h3>
        <p className="text-white/85 text-sm mb-5 max-w-md mx-auto">
          Submit your funniest cat memes and get featured on MeowCentral! The best ones get shared to our 500k+ community every week.
        </p>
        <a
          href="/contact"
          className="inline-flex items-center gap-2 bg-white text-teal-600 font-bold px-6 py-3 rounded-full hover:bg-teal-50 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-upload-cloud-line text-lg"></i>
          Submit Your Meme
        </a>
      </div>
    </motion.div>
  );
}
